/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsnoemail2Inputs */

const en_signupsnoemail2 = /** @type {(inputs: Signupsnoemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No address`)
};

const de_signupsnoemail2 = /** @type {(inputs: Signupsnoemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Adresse`)
};

/**
* | output |
* | --- |
* | "No address" |
*
* @param {Signupsnoemail2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsnoemail2 = /** @type {((inputs?: Signupsnoemail2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsnoemail2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsnoemail2(inputs)
	return de_signupsnoemail2(inputs)
});
export { signupsnoemail2 as "signupsNoEmail" }